import React from 'react'

import {
  Telephone,
  HouseFill,
} from 'react-bootstrap-icons'

interface Props {
  address: any
}

export default function AddressItem({address}: Props) {
  return (
    <div className="rounded bg-white overflow-hidden border border-gray">
      <div className="d-flex align-items-center p-4 border-bottom border-light">
        <HouseFill size={20} className="mr-3 mb-1" />
        <p className="mb-0"><strong>{address.street_address_1}</strong></p>
        {!!address.street_address_2?.length && (
          <p className="mb-0"><strong className="mr-2">,</strong>{address.street_address_2}</p>
        )}
      </div>
      <div className="d-flex justify-content-between align-items-center px-4 py-3">
        <p className="mb-0 text-black-50">{address.postal_code} {address.city}</p>
        <div className="d-flex align-items-center">
          <Telephone size={15} className="text-black-50 mr-2 mb-1" />
          <p className="mb-0 text-black-50">{address.phone || '-'}</p>
        </div>
      </div>
    </div>
  )
}
